// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__6TKpo","overflowing":"ReadFullNote_overflowing__3rLRb"};